import clearModal from 'root/src/client/logic/static/actions/clearModal'

export default () => dispatch => dispatch(clearModal())
